import React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import History from '../../domain/History';
import HistoryPrintingListingMonth from './HistoryPrintingListingMonth';

const Table = styled.table`
  ${({ theme }) => `
    width: 100%;
    table-layout: fixed;
    margin-top: ${theme.metrics.largeMargin}px;
    border-collapse: collapse;

    td, th {
      padding: ${theme.metrics.smallMargin}px;
    }
  `}
`;

const TableHeader = styled.tr`
  @media print {
    box-shadow: inset 0 0 0 1000px rgba(19, 168, 158, 0.4);
  }

  @media screen {
    background-color: rgba(19, 168, 158, 0.4);
  }
`;

const ListingHeaderText = styled.th`
  ${({ theme }) => `
    font-size: ${theme.fonts.style.midSmall.fontSize}px;
    font-weight: ${theme.fonts.weights.bolder};
    text-align: center;
    color: ${theme.colors.secondaryText};
  `}
`;

const Colgroup = styled.colgroup`
  col:first-child {
    width: 40%;
  }

  col:not(:first-child) {
    width: 30%;
  }
`;

type Props = {
  history: History;

  t: any;
}

export function HistoryPrintingListing({ t, history }: Props) {
  return (
    <Table>
      <Colgroup>
        <col />
        <col />
        <col />
      </Colgroup>
      <thead>
        <TableHeader>
          <ListingHeaderText>{t('week')}</ListingHeaderText>
          <ListingHeaderText>{t('reach')}</ListingHeaderText>
          <ListingHeaderText>{t('listeningTime')}</ListingHeaderText>
        </TableHeader>
      </thead>
      <tbody>
        {history.groupByMonth().map((month) => {
          return (
            <HistoryPrintingListingMonth month={month} key={month.month} />
          );
        })}
      </tbody>
    </Table>
  );
}

export default translate()(HistoryPrintingListing);



// WEBPACK FOOTER //
// ./src/statsradio/modules/history/printing/components/HistoryPrintingListing.js